module.exports = __webpack_public_path__ + "static/noticias-12-a133591a7445d224cf3fac84ece0317a.jpg";